import React from "react";
import CustomeDesignVideo from "../../../Assets/images/cultured-img/custom-design.mp4";
import "../../../Assets/css/culturedbrillianceCustomDesign.css";
import { Col, Container, Row, Form } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import "../../../Assets/css/mjstatic.css";
import { base_url } from "../../../Helpers/request";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useEffect, useRef } from "react";
const CbCustomeDesignPage = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const playVideo = async () => {
      if (videoRef.current) {
        try {
          await videoRef.current.play();
        } catch (error) {
          console.error("Autoplay was prevented:", error);
        }
      }
    };

    playVideo();
  }, []);

  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const history = useHistory();
  const [chooseType, setChooseType] = React.useState("");
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [budget, setBudget] = React.useState("");
  const [notes, setNotes] = React.useState("");
  const [material, setMaterial] = React.useState("");
  const [image, setImage] = React.useState(null);
  const [error, setError] = React.useState(false);
  const handleChangeChooseType = (event) => {
    setChooseType(event.target.value);
  };
  const handleChangeMaterial = (event) => {
    setMaterial(event.target.value);
  };
  const postform = (e) => {
    e.preventDefault();
    var data = {
      name,
      email,
      mobile,
      budget,
      notes,
      material,
      image,
    };

    let formData = new FormData();
    formData.append("type", chooseType);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobile", mobile);
    formData.append("budget", budget);
    formData.append("material", material);
    formData.append("note", notes);
    formData.append("file", image);
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    axios
      .post(base_url + "/common/customProductRequest", formData, config)
      .then((response) => {
        if (response.data.status == 1) {
          swal(response.data.message, "", "success");
        } else {
          swal(response.data.message, "", "error");
        }
        setName("");
        setEmail("");
        setMobile("");
        setBudget("");
        setNotes("");
        setMaterial("");
        setImage("");
        setError(false)
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>

      <div className="cb_custome_design_Section">
        <Container className="cb_cutome_design_container">
          <Row>
            <Col sm={12} md={6} lg={6} className="order_2">
              <video
                ref={videoRef}
                width="100%"
                height="100%"
                autoplay="autoplay"
                loop
                muted
              >
                <source src={CustomeDesignVideo} type="video/mp4" />
                <source src={CustomeDesignVideo} type="video/ogg" />
                Your browser does not support the video tag.
              </video>
            </Col>
            <Col
              sm={12}
              md={6}
              lg={6}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="cb_custom_heading text-center">
                <h2>CUSTOM DESIGN</h2>
                <p>
                  Customized jewelry is really special. If reflects you vision
                  and intention and adds value beyond dollars. We'd love to work
                  with you - and here's how we do it:
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={6} lg={6}>
              <div className="cb_custome_Design_step_box">
                <h3>Step 1 – CAD Rendering</h3>
                <p>
                  Share your ideas by calling, visiting or sending us a drawing!
                  Use the Request a Quote button to upload your pictures!{" "}
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={6}>
              <div className="cb_custome_Design_step_box">
                <h3>Step 2 – Wax Mold</h3>
                <p>
                  Once the CAD is approved, we plug the design file into a 3D
                  printing machine. Using high-quality wax resin material, the
                  machine grows a wax mold of your product. You can physically
                  inspect this mold and try it on to understand how the final
                  product will be.{" "}
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={6}>
              <div className="cb_custome_Design_step_box">
                <h3>Step 3 – Casting</h3>
                <p>
                  The wax mold is then put into our oven where it is cast into
                  your desired metal. Once cool, the raw casting is then
                  polished and prepared for the final stage of production. At
                  this stage, you can know how your jewelry will look before any
                  stones are fitted.{" "}
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={6}>
              <div className="cb_custome_Design_step_box">
                <h3>Step 4 – Finishing</h3>
                <p>
                  At this stage, the stones are selected and fitted into the
                  jewelry using a microscope to ensure the stones are firmly
                  established. All the special textures like brushing,
                  engraving, etc. are added after the stones are placed. The
                  product is then polished to be delivered in its pristine form.{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="rcs_new_custome_page_form rcs_account_content_left mt-3 mb-5">
          <Container className="cb_cutome_design_container p-0">
            <Row className="m-auto w-100">
              <Col xs={12}>
                <h4 className="mb-5">LET'S START YOUR PROJECT!</h4>
              </Col>
            </Row>
            <Form onSubmit={postform}>
              <Row className="m-auto w-100">
                <Col md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="rcs_choose_type">Choose Type</InputLabel>
                    <Select
                      labelId="rcs_choose_type"
                      value={chooseType}
                      label="Choose Type"
                      onChange={handleChangeChooseType}
                      required
                    >
                      <MenuItem value="Bracelet">Bracelet</MenuItem>
                      <MenuItem value="Chain">Chain</MenuItem>
                      <MenuItem value="Pendant">Pendant</MenuItem>
                      <MenuItem value="Ring">Ring</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
                <Col md={6}>
                  <TextField
                    label="Name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    variant="outlined"
                  ></TextField>
                </Col>
                <Col md={6}>
                  <TextField
                    label="Email Address"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    variant="outlined"
                  ></TextField>
                </Col>
                <Col md={6}>
                  <TextField
                    label="Mobile Number"
                    type="number"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                    variant="outlined"
                  ></TextField>
                </Col>
                <Col md={6}>
                  <TextField
                    label="Total Budget"
                    type="number"
                    value={budget}
                    onChange={(e) =>{ setBudget(e.target.value);
                       if (e.target.value === '0') {
                      setError(true);
                  } else {
                      setError(false);
                  }}}
                    required
                    variant="outlined"
                    error={error}
                    helperText={error ? "Budget must be greater than 0" : ""}
                    
                  ></TextField>
                </Col>
                <Col md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="rcs_metal_type" htmlFor='MetalType'>Metal Type</InputLabel>
                    <Select
                      labelId="rcs_metal_type"
                      value={material}
                      label="Metal Type"
                      id="MetalType"
                      onChange={handleChangeMaterial}
                    >
                      <MenuItem value="10k Gold">10k Gold</MenuItem>
                      <MenuItem value="14k Gold">14k Gold</MenuItem>
                      <MenuItem value="18k Gold">18k Gold</MenuItem>
                      <MenuItem value="22k Gold">22k Gold</MenuItem>
                      <MenuItem value="24 Gold">24k Gold</MenuItem>
                      <MenuItem value="Platinum">Platinum</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
                <Col md={6}>
                  <TextField
                    label="Notes"
                    type="text"
                    multiline
                    InputLabelProps={{
                      shrink: true,
                    }}
                    rows={4}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Please describe your idea for this Custom Project and provide us with as many details as you can, so we can get back to you with a quote for your Custom Jewelry."
                    variant="outlined"
                  ></TextField>
                </Col>
                <Col md={6}>
                  <TextField
                    label="Upload"
                    type="file"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => setImage(e.target.files[0])}
                    helperText="Choose your file here to upload. Allowed type(pdf,jpg,png,jpeg,doc,docx)"
                  ></TextField>
                </Col>
                <Col xs={12} className="mt-3">
                  <Button
                    variant="contained"
                    type="submit"
                    className="rcs_acc_button rcs_review_btn"
                    disabled={error}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </Container>
        </div>
      </div>
    </>
  );
};

export default CbCustomeDesignPage;
